module.exports = __webpack_public_path__ + "img/t3-c5.085e2edf.png";